// menuConfig.js
import {
    getHyperionElements,
    getHaronElements,
    getPhoebusElements,
    getRhodesElements,
    getLeonElements,
    getChoiceElements
} from './mapUtils';

function createItem(id, label, options = {}) {
    return { id, label, ...options };
}

/**
 * Рекурсивно обрезает дерево меню:
 * - Узлы с image считаются листьями и сохраняются.
 * - Узлы с children обрезаются: сохраняются только дети, которые не null.
 * - Узлы без image и непустых children удаляются.
 * - Узлы с levels (старая структура) сохраняются, если хотя бы один уровень имеет image.
 */
function pruneNode(node) {
    if (!node) return null;

    if (node.image) {
        return node;
    }

    if (node.levels && Array.isArray(node.levels) && node.levels.length > 0) {
        const hasValidLevel = node.levels.some(level => level.image);
        if (hasValidLevel) {
            return node;
        }
        return null;
    }

    if (node.children && Array.isArray(node.children)) {
        const prunedChildren = node.children
            .map(child => pruneNode(child))
            .filter(child => child !== null);

        if (prunedChildren.length === 0) {
            return null;
        }

        return { ...node, children: prunedChildren };
    }

    return null;
}

// Исходная конфигурация
let rawConfig = [
    // ----- Карта Мира -----
    createItem('world', 'Карта Мира', {
        children: [
            createItem('hyper', 'Гиперион', {
                image: '/image/hyper',
                elementsSource: getHyperionElements
            }),
            createItem('haron', 'Харон', {
                image: '/image/haron',
                elementsSource: getHaronElements
            }),
            createItem('phoebus', 'Феб', {
                image: '/image/phoebus',
                elementsSource: getPhoebusElements
            }),
            createItem('rhodes', 'Родос', {
                image: '/image/rhodes',
                elementsSource: getRhodesElements
            }),
            createItem('choice', 'о. Выбора', {
                image: '/image/choice',
                elementsSource: getChoiceElements
            }),
            createItem('leon', 'о. Леон', {
                image: '/image/leon-with-castle',
                elementsSource: getLeonElements
            }),
        ]
    }),

    // ----- Все Данжи -----
    createItem('dungeons', 'Данжи', {
        children: [
            // ----- Квестовые (закомментированы, можно раскомментировать при необходимости) -----
            createItem('quest', 'Квестовые', {
                children: [
                    createItem('prison', 'Тюрьма', {
                        children: [
                            createItem('prison-1', 'Тюрьма 1', {
                                children: [
                                    createItem('prison-1-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-prison-1',
                                        elementsKey: 'dungeon-quest-prison-1',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'prison-1-0',
                                isDungeon: true,
                            }),
                            createItem('prison-2', 'Тюрьма 2', {
                                children: [
                                    createItem('prison-2-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-prison-2',
                                        elementsKey: 'dungeon-quest-prison-2',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'prison-2-0',
                                isDungeon: true,
                            }),
                        ]
                    }),
                    createItem('hole', 'Нора', {
                        children: [
                            createItem('hole-1', 'Нора 1', {
                                children: [
                                    createItem('hole-1-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-hole-1',
                                        elementsKey: 'dungeon-quest-hole-1',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'hole-1-0',
                                isDungeon: true,
                            }),
                            createItem('hole-2', 'Нора 2', {
                                children: [
                                    createItem('hole-2-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-hole-2',
                                        elementsKey: 'dungeon-quest-hole-2',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'hole-2-0',
                                isDungeon: true,
                            }),
                            createItem('hole-3', 'Нора 3', {
                                children: [
                                    createItem('hole-3-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-hole-3',
                                        elementsKey: 'dungeon-quest-hole-3',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'hole-3-0',
                                isDungeon: true,
                            }),
                        ]
                    }),
                    createItem('mineshaft', 'Шахта', {
                        children: [
                            createItem('mineshaft-1', 'Шахта 1', {
                                children: [
                                    createItem('mineshaft-1-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-mineshaft-1-0',
                                        elementsKey: 'dungeon-quest-mineshaft-1-0',
                                        isLevel: true
                                    }),
                                    createItem('mineshaft-1-1', 'Ярус 2', {
                                        image: '/image/dungeon-quest-mineshaft-1-1',
                                        elementsKey: 'dungeon-quest-mineshaft-1-1',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'mineshaft-1-0',
                                isDungeon: true,
                            }),
                            createItem('mineshaft-2', 'Шахта 2', {
                                children: [
                                    createItem('mineshaft-2-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-mineshaft-2',
                                        elementsKey: 'dungeon-quest-mineshaft-2',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'mineshaft-2-0',
                                isDungeon: true,
                            }),
                            createItem('mineshaft-3', 'Шахта 3', {
                                children: [
                                    createItem('mineshaft-3-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-mineshaft-3',
                                        elementsKey: 'dungeon-quest-mineshaft-3',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'mineshaft-3-0',
                                isDungeon: true,
                            }),
                            createItem('mineshaft-4', 'Шахта 4', {
                                children: [
                                    createItem('mineshaft-4-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-mineshaft-4-0',
                                        elementsKey: 'dungeon-quest-mineshaft-4-0',
                                        isLevel: true
                                    }),
                                    createItem('mineshaft-4-1', 'Ярус 2', {
                                        image: '/image/dungeon-quest-mineshaft-4-1',
                                        elementsKey: 'dungeon-quest-mineshaft-4-1',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'mineshaft-4-0',
                                isDungeon: true,
                            }),
                            createItem('mineshaft-5', 'Шахта 5', {
                                children: [
                                    createItem('mineshaft-5-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-mineshaft-5',
                                        elementsKey: 'dungeon-quest-mineshaft-5',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'mineshaft-5-0',
                                isDungeon: true,
                            }),
                        ]
                    }),
                    createItem('cave', 'Пещера', {
                        children: [
                            createItem('cave-1', 'Пещера 1', {
                                children: [
                                    createItem('cave-1-0', 'Ярус 1', {
                                        image: '/image/dungeon-quest-cave-1',
                                        elementsKey: 'dungeon-quest-cave-1',
                                        isLevel: true
                                    }),
                                ],
                                defaultLevel: 'cave-1-0',
                                isDungeon: true,
                            }),
                        ]
                    }),
                ]
            }),

            // ----- Замковые -----
            createItem('castle', 'Замковые', {
                children: [
                    createItem('castle_hyper', 'Гиперион', {
                        children: [
                            createItem('15', '15 уровень', { children: [] }),
                            createItem('30', '30 уровень', { children: [] }),
                            createItem('45', '45 уровень', { children: [] }),
                        ]
                    }),
                    createItem('castle_charon', 'Харон', {
                        children: [
                            createItem('60', '60 уровень', { children: [] }),
                            createItem('75', '75 уровень', { children: [] }),
                            createItem('90', '90 уровень', { children: [] }),
                        ]
                    }),
                    createItem('castle_phoebus', 'Феб', {
                        children: [
                            createItem('120', '120 уровень', {
                                children: [
                                    createItem('castle_phoebus_elec', 'Элек', {
                                        children: [
                                            createItem('elec-level-0', 'Ярус 1', {
                                                image: '/image/dungeon-castle-elec-0',
                                                elementsKey: 'castle_phoebus_elec_floor_1',
                                                isLevel: true
                                            }),
                                        ],
                                        defaultLevel: 'elec-level-0',
                                        isDungeon: true,
                                    }),
                                    createItem('castle_phoebus_gavot', 'Гавот', {
                                        children: [
                                            createItem('gavot-level-0', 'Ярус 1', {
                                                image: '/image/dungeon-castle-gavot-0',
                                                elementsKey: 'castle_phoebus_gavot_floor_1',
                                                isLevel: true
                                            }),
                                        ],
                                        defaultLevel: 'gavot-level-0',
                                        isDungeon: true,
                                    }),
                                ]
                            }),
                            createItem('250', '250 уровень', {
                                children: [
                                    createItem('castle_phoebus_candour', 'Кандур', {
                                        children: [
                                            createItem('candour-level-0', 'Ярус 1', {
                                                image: '/image/dungeon-castle-kandur-0',
                                                elementsKey: 'castle_phoebus_candour_floor_1',
                                                isLevel: true
                                            }),
                                            createItem('candour-level-1', 'Ярус 2', {
                                                image: '/image/dungeon-castle-kandur-1',
                                                elementsKey: 'castle_phoebus_candour_floor_2',
                                                isLevel: true
                                            }),
                                        ],
                                        defaultLevel: 'candour-level-0',
                                        isDungeon: true,
                                    }),
                                ]
                            }),
                        ]
                    }),
                    createItem('castle_rhodes', 'Родос', {
                        children: [
                            createItem('60', '60 уровень', { children: [] }),
                            createItem('75', '75 уровень', { children: [] }),
                            createItem('90', '90 уровень', { children: [] }),
                            createItem('120', '120 уровень', { children: [] }),
                            createItem('250', '250 уровень', { children: [] }),
                        ]
                    }),
                    createItem('castle_leon', 'о. Леон', {
                        children: [
                            createItem('350', '350 уровень', { children: [] }),
                        ]
                    }),
                ]
            }),

            // ----- Кладбища (новый раздел) -----
            createItem('graveyards', 'Кладбища', {
                children: [
                    createItem('graveyard_hyper', 'Гиперион', {
                        children: [
                            createItem('graveyard_torvil', 'Торвиль', {
                                children: [
                                    createItem('graveyard_torvil_floor_1', 'Этаж 1', {
                                        children: [
                                            createItem('graveyard-torvil-1-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-torvil-1-0',
                                                elementsKey: 'graveyard-torvil-floor-1-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-torvil-1-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-torvil-1-1',
                                                elementsKey: 'graveyard-torvil-floor-1-1',
                                                isLevel: true
                                            }),
                                        ],
                                        defaultLevel: 'graveyard-torvil-1-0',
                                        isDungeon: true,
                                    }),
                                    createItem('graveyard_torvil_floor_2', 'Этаж 2', {
                                        children: [
                                            createItem('graveyard-torvil-2-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-torvil-2-0',
                                                elementsKey: 'graveyard-torvil-floor-2-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-torvil-2-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-torvil-2-1',
                                                elementsKey: 'graveyard-torvil-floor-2-1',
                                                isLevel: true
                                            }),
                                        ],
                                        defaultLevel: 'graveyard-torvil-2-0',
                                        isDungeon: true,
                                    })
                                ],
                            }),
                            createItem('graveyard_bangvil', 'Бангвиль', {
                                children: [
                                    createItem('graveyard_bangvil_floor_1', 'Этаж 1', {
                                        children: [
                                            createItem('graveyard-bangvil-1-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-bangvil-1-0',
                                                elementsKey: 'graveyard-bangvil-floor-1-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-bangvil-1-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-bangvil-1-1',
                                                elementsKey: 'graveyard-bangvil-floor-1-1',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-bangvil-1-2', 'Ярус 3', {
                                                image: '/image/dungeon-graveyard-bangvil-1-2',
                                                elementsKey: 'graveyard-bangvil-floor-1-2',
                                                isLevel: true
                                            })
                                        ],
                                        defaultLevel: 'graveyard-bangvil-1-0',
                                        isDungeon: true,
                                    }),
                                    createItem('graveyard_bangvil_floor_2', 'Этаж 2', {
                                        children: [
                                            createItem('graveyard-bangvil-2-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-bangvil-2-0',
                                                elementsKey: 'graveyard-bangvil-floor-2-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-bangvil-2-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-bangvil-2-1',
                                                elementsKey: 'graveyard-bangvil-floor-2-1',
                                                isLevel: true
                                            })
                                        ],
                                        defaultLevel: 'graveyard-bangvil-2-0',
                                        isDungeon: true,
                                    }),
                                ],
                            }),
                            createItem('graveyard_shipstone', 'Шипстоун', {
                                children: [
                                    createItem('graveyard_shipstone_floor_1', 'Этаж 1', {
                                        children: [
                                            createItem('graveyard-shipstone-1-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-shipstone-1-0',
                                                elementsKey: 'graveyard-shipstone-floor-1-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-shipstone-1-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-shipstone-1-1',
                                                elementsKey: 'graveyard-shipstone-floor-1-1',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-shipstone-1-2', 'Ярус 3', {
                                                image: '/image/dungeon-graveyard-shipstone-1-2',
                                                elementsKey: 'graveyard-shipstone-floor-1-2',
                                                isLevel: true
                                            })
                                            ,
                                            createItem('graveyard-shipstone-1-3', 'Ярус 4', {
                                                image: '/image/dungeon-graveyard-shipstone-1-3',
                                                elementsKey: 'graveyard-shipstone-floor-1-3',
                                                isLevel: true
                                            })
                                        ],
                                        defaultLevel: 'graveyard-shipstone-1-1',
                                        isDungeon: true,
                                    }),
                                ],
                            }),
                            createItem('graveyard_sunpool', 'Санпул', {
                                children: [
                                    createItem('graveyard_sunpool_floor_1', 'Этаж 1', {
                                        children: [
                                            createItem('graveyard-sunpool-1-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-sunpool-1-0',
                                                elementsKey: 'graveyard-sunpool-floor-1-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-1-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-sunpool-1-1',
                                                elementsKey: 'graveyard-sunpool-floor-1-1',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-1-2', 'Ярус 3', {
                                                image: '/image/dungeon-graveyard-sunpool-1-2',
                                                elementsKey: 'graveyard-sunpool-floor-1-2',
                                                isLevel: true
                                            })
                                        ],
                                        defaultLevel: 'graveyard-sunpool-1-1',
                                        isDungeon: true,
                                    }),
                                    createItem('graveyard_sunpool_floor_2', 'Этаж 2', {
                                        children: [
                                            createItem('graveyard-sunpool-2-0', 'Ярус 1', {
                                                image: '/image/dungeon-graveyard-sunpool-2-0',
                                                elementsKey: 'graveyard-sunpool-floor-2-0',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-2-1', 'Ярус 2', {
                                                image: '/image/dungeon-graveyard-sunpool-2-1',
                                                elementsKey: 'graveyard-sunpool-floor-2-1',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-2-2', 'Ярус 3', {
                                                image: '/image/dungeon-graveyard-sunpool-2-2',
                                                elementsKey: 'graveyard-sunpool-floor-2-2',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-2-3', 'Ярус 4', {
                                                image: '/image/dungeon-graveyard-sunpool-2-3',
                                                elementsKey: 'graveyard-sunpool-floor-2-3',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-2-4', 'Ярус 5', {
                                                image: '/image/dungeon-graveyard-sunpool-2-4',
                                                elementsKey: 'graveyard-sunpool-floor-2-4',
                                                isLevel: true
                                            }),
                                            createItem('graveyard-sunpool-2-5', 'Ярус 6', {
                                                image: '/image/dungeon-graveyard-sunpool-2-5',
                                                elementsKey: 'graveyard-sunpool-floor-2-5',
                                                isLevel: true
                                            })
                                        ],
                                        defaultLevel: 'graveyard-sunpool-2-1',
                                        isDungeon: true,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),

            // ----- Прочие (Фебоданж) -----
            createItem('others', 'Прочие', {
                children: [
                    createItem('febodanj', 'Фебоданж', {
                        children: [
                            createItem('floor-1', 'Этаж 1', {
                                children: [
                                    createItem('fd-1-0', 'Ярус 1', { image: '/image/dungeon-others-fd-1-0', elementsKey: 'fd-1-0', isLevel: true }),
                                    createItem('fd-1-1', 'Ярус 2', { image: '/image/dungeon-others-fd-1-1', elementsKey: 'fd-1-1', isLevel: true }),
                                    createItem('fd-1-2', 'Ярус 3', { image: '/image/dungeon-others-fd-1-2', elementsKey: 'fd-1-2', isLevel: true }),
                                ],
                                defaultLevel: 'fd-1-1',
                                isDungeon: true,
                            }),
                            createItem('floor-2', 'Этаж 2', {
                                children: [
                                    createItem('fd-2-0', 'Ярус 1', { image: '/image/dungeon-others-fd-2-0', elementsKey: 'fd-2-0', isLevel: true }),
                                    createItem('fd-2-1', 'Ярус 2', { image: '/image/dungeon-others-fd-2-1', elementsKey: 'fd-2-1', isLevel: true }),
                                    createItem('fd-2-2', 'Ярус 3', { image: '/image/dungeon-others-fd-2-2', elementsKey: 'fd-2-2', isLevel: true }),
                                ],
                                defaultLevel: 'fd-2-1',
                                isDungeon: true,
                            }),
                            createItem('floor-3', 'Этаж 3', {
                                children: [
                                    createItem('fd-3-0', 'Ярус 1', { image: '/image/dungeon-others-fd-3-0', elementsKey: 'fd-3-0', isLevel: true }),
                                    createItem('fd-3-1', 'Ярус 2', { image: '/image/dungeon-others-fd-3-1', elementsKey: 'fd-3-1', isLevel: true }),
                                    createItem('fd-3-2', 'Ярус 3', { image: '/image/dungeon-others-fd-3-2', elementsKey: 'fd-3-2', isLevel: true }),
                                    createItem('fd-3-3', 'Ярус 4', { image: '/image/dungeon-others-fd-3-3', elementsKey: 'fd-3-3', isLevel: true }),
                                ],
                                defaultLevel: 'fd-3-3',
                                isDungeon: true,
                            }),
                            createItem('floor-4', 'Этаж 4', {
                                children: [
                                    createItem('fd-4-0', 'Ярус 1', { image: '/image/dungeon-others-fd-4-0', elementsKey: 'fd-4-0', isLevel: true }),
                                    createItem('fd-4-1', 'Ярус 2', { image: '/image/dungeon-others-fd-4-1', elementsKey: 'fd-4-1', isLevel: true }),
                                    createItem('fd-4-2', 'Ярус 3', { image: '/image/dungeon-others-fd-4-2', elementsKey: 'fd-4-2', isLevel: true }),
                                ],
                                defaultLevel: 'fd-4-1',
                                isDungeon: true,
                            }),
                        ]
                    })
                ]
            }),
        ]
    })
];

// Применяем обрезку к корневым элементам
const menuConfig = rawConfig
    .map(node => pruneNode(node))
    .filter(node => node !== null);

export default menuConfig;